import React, { Component } from "react";
import { connect } from "react-redux";
import axios, { CancelToken } from "axios";
import { Translate, I18n } from "react-redux-i18n";
import { setAlert } from "../../../actions/alertActions";
import {
  updateAccountData,
  updatePreferences,
} from "../../../actions/accountActions";
import "../../../styles/components/account/manageAccount/NotificationInfo.scss";
import pencil from "../../../styles/images/pencil.svg";

class NotificationInfo extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;

    this.state = {
      edit: false,
      licenseServices: this.props.accountData.licenseServices,
      licenseProducts: this.props.accountData.licenseProducts,
      licenseMarketing: this.props.accountData.licenseMarketing,
    };

  }

  componentDidMount() {
    this._mounted = true;
    if (this.state.zipCode !== "") {
      this.safeSetState({
        zipcode_valid: true,
      });
    }
  }

  componentWillUnmount() {
    this._mounted = false;
    if (this.cancel) this.cancel("Component is unmounting");
  }

  handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    this.setState({
      [name]: checked,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { licenseMarketing, licenseProducts, licenseServices  } = this.state;
    const acd = this.props.accountData;
    if(this.state.edit){
      const patch = {
        licenseMarketing: licenseMarketing,
        licenseProducts: licenseProducts,
        licenseServices: licenseServices,
      };
  
      axios
        .patch(
          "/api/private/users/licensePreferences",
          patch,
          {
            cancelToken: new CancelToken((c) => (this.cancel = c)),
          }
        )
        .then((res) => {
          this.props.updateAccountData(
            acd.accountData.internationalPrefix,
            acd.accountData.phone
          );
          this.props.setAlert(I18n.t("editAccount_profileUpdatedSuccessfully"), "primary");
        }).catch(() => {
          this.props.setAlert(I18n.t("general_error"), "danger");
        })
    }
    this.safeSetState((prevState) => ({
      edit: !prevState.edit,
    }));
  };

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <div id="info" className="evio-container">
        <div className="top-bar">
          <p className="title">
            {I18n.t("notificationInfo_moduleTitle")}
          </p>
          <button
            type="submit"
            form={`${this.props.mode}-address-form`}
            className={this.state.edit ? "save-btn" : "clear"}
            onClick={this.handleSubmit}
          >
            {this.state.edit ? (
              <Translate value="editAccount_saveButton" />
            ) : (
              <img src={pencil} alt={I18n.t("editAccount_editLabel")} />
            )}
          </button>
        </div>
        <form className="checkbox-form">
          <div className="checkbox-container">
            <input
              type="checkbox"
              name="licenseServices"
              checked={this.state.licenseServices}
              onChange={this.handleCheckboxChange}
              disabled={!this.state.edit}
              className="cb"
            />
            <div className="checkbox-description">
              {I18n.t("notification_licenseServices") + " " + this.props.brand.brandName.toLowerCase()}
            </div>
          </div>

          <div className="checkbox-container">
            <input
              type="checkbox"
              name="licenseProducts"
              checked={this.state.licenseProducts}
              onChange={this.handleCheckboxChange}
              disabled={!this.state.edit}
              className="cb"
            />
            <div className="checkbox-description">
              {I18n.t("notification_licenseProducts") + " " + this.props.brand.brandName.toLowerCase()}
            </div>
          </div>        
          <div className="checkbox-container">
            <input
              type="checkbox"
              name="licenseMarketing"
              checked={this.state.licenseMarketing}
              onChange={this.handleCheckboxChange}
              disabled={!this.state.edit}
              className="cb"
            />
            <div className="checkbox-description">
              {I18n.t("notification_licenseMarketing") + " " + this.props.brand.brandName.toLowerCase()}
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  brand: state.app.brand,
  accountData: state.account,
  isCompany: state.account.isCompany,
  all: state
});

export default connect(mapStateToProps, {
  setAlert,
  updateAccountData,
  updatePreferences,
})(NotificationInfo);
